var confirmPassword = (function ($) {

    function decisionPopup() {
        var decisionPopup = window.kos && kos.dialog && kos.dialog.decisionPopup || window.app && app.dialog && app.dialog.decisionPopup;
        return decisionPopup();
    }

    function popup() {
        var popup = window.kos && kos.dialog && kos.dialog.popup || window.app && app.dialog && app.dialog.popup;
        return popup;
    }

    function _confirm(input, dialog, cb) {
        var password = input.val();
        input.toggleClass('errorField', !password);
        if (!!password && $.isFunction(cb)) {
            cb(password, dialog.destroy);
        }
    }

    return function (email, accountExists, cb) {
        var dialog = decisionPopup();
        var $el = dialog.$el.html($.tmpl('confirm_password', { Email: email, AccountExists: accountExists }));
		var $input = $el.find('@confirm-password-input');

		$el.find('@close-confirm-password').click(function (e) {
			e.preventDefault();
			e.stopPropagation();
		    dialog.destroy();
		});

        $input.focus();

        $el.find('@confirm-password_button').on('click', function () {
            _confirm($input, dialog, cb);
        });

        $input.on('keydown', function (e) {
            if (e.which == 13) {
                _confirm($input, dialog, cb);
                e.preventDefault();
                e.stopPropagation();
            }
        });

	    !email && $el.find('@recovery-password').remove();
        email && $el.find('@recovery-password-container').on('click', function () {
            api.forgotPassword(email).done(function (data) {
                var text = window.PageTemplates ? PageTemplates.get("_PasswordRecovery") : GetPageTemplate("_PasswordRecovery");
                var dialog = popup();
                dialog({
                    title: '',
                    message: text
                });
            });
        });
    };
})(jQuery);